import React from 'react';
// SLICK SLIDER
import Slider from 'react-slick';
// IMAGE
import comment from '@images/Depoimentos/comment.png';
// MATERIAL-UI
import {
  CircularProgress,
  useTheme,
  useMediaQuery,
} from '@material-ui/core';
// GRAPHQL
import getNpsFeedbacks from '../../graphql/schemas/GetNpsFeedbacks';
// STYLES
import useStyles from './style';

const SimpleSlider = () => {
  const classes = useStyles();
  const theme = useTheme();
  const mediaQuerySM = useMediaQuery(theme.breakpoints.down('sm'));
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000,
  };
  const [infos, setInfos] = React.useState([]);
  const [loading, setLoading] = React.useState(true);

  const loadFeedbacks = () => {
    getNpsFeedbacks()
      .then((r) => setInfos(r.data))
      .catch((err) => console.log(err))
      .finally(() => setLoading(false));
  };

  React.useEffect(() => {
    loadFeedbacks();
  });

  return (
    <>
   
    </>
  );
};

export default SimpleSlider;
